export const DELETE_SR_FAMILY_MEMBER_MODAL_NAME =
  'DELETE_SR_FAMILY_MEMBER_MODAL_NAME';
